<template>
<div :style="sectionOuter" :class="sectionClass">
    <div :style="sectionHeading" @click="editSection">
        {{section.title}} ({{componentWidth}})
        <div style="float:right">
            <v-icon @click="settings.editing = !settings.editing" dark small>create</v-icon>
        </div>
    </div>
    <div class="section-content" :style="sectionContentStyle">
        <div class="column-outer" :style="columnOuterStyle(column)" v-for="(column, colIndex) in section.columns" :key="colIndex">
                <div class="column-inner" style="width:100%;">

                    <div :style="sectionHeading" @click="editColumn(colIndex)">
                        {{column.title}}
                    </div>
                    <draggable style="width:100%" class="column-detail draggable-container" v-model="column.elements" :options="{ animation: 350, group:'elements', xxxhandle: '.menu-icon'}" @end="afterDrag">
                        <template v-for="(element, elIndex) in column.elements">
                            <ControlElement :element="element" :settings="pageSettings" @click="elementClicked" :key="elIndex" />
                        </template>
                    </draggable>

                </div>
        </div>
    </div>

<portal to="sidebar" >
    <EditPanel class="pa-2" :element="elementEditing" @button-click="editPanelButtonClick" />
</portal>

    <ElementDialog :settings="elementDialog.settings" :element="section" />
    

</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import FireData from '../data/FireData'
import ElementDialog from '../builder/ElementDialog'
import EditPanel from '../builder/EditPanel'
import ControlElement from '../builder/ControlElement'
import Utilities from '../helpers/Utilities'
import draggable from 'vuedraggable'


export default {
    data() {
        return {
            componentWidth: null,
            settings: {
                editing: false,
                narrow: false,
            },
            elementDialog: {
                settings: {
                    visible: false,
                    title: 'Section Details'
                }
            },

            elementEditing: {},

        }
    },


    components: {
        ElementDialog,
        EditPanel,
        ControlElement,
        draggable,
    },
    
    props: {
        section: Object,
    },

    computed: {
        pageSettings() {
            let settings = {
                narrow: this.narrow,
                editing: this.settings.editing,
                elementEditing: this.elementEditing,
            }
            return settings
        },
        narrow() {
            return this.componentWidth < 400
        },
        sectionOuter() {
            return {
                'border-style': (this.settings.editing ? 'dashed' : 'solid'),
                'border-width': '2px',
                'border-color': (this.settings.editing ? '#ddd' : 'transparent'),
                'border-radius': '5px',
                'padding': '3px',
                'background-color': (this.section.background || ''),
            }
        },
        sectionContentStyle() {
            let style = {}
            style.display = this.narrow ? 'block' : 'flex'
            return style
        },

        sectionClass() {
            return 'section' //come back later
            + (!this.settings.editing ? ' elevation-1' : '')
        },
        sectionHeading() {
            return "margin:5px;padding:6px 10px;color:white;background-color: #aaa;font-weight:600;border-radius:5px;text-transform: uppercase;"
        },
        page() {
            return this.$route.params.page
        },
        // dynamicStyles() {
        //     let narrow = this.componentWidth < 300
        //     let styles = {}
        //     styles.sectionDisplay = (narrow ? 'block' : 'flex')
        // }
    },

    methods: {
        columnOuterStyle(column) {
            return {
                'background-color': (column.background || ''),
                'border-radius': '5px',
                'width': (column.width && !this.narrow ? column.width + '%' : '')
            }
        },

        showElementDialog() {
            this.elementDialog.settings.visible = true
        },
        editSection() {
            this.elementEditing = this.section
        },
        editColumn(colIndex) {
            this.elementEditing = this.section.columns[colIndex]
        },
        elementClicked(element) {
            this.elementEditing = element
        },
        editPanelButtonClick(eventString, payload) {
            if(eventString == 'add-column') {
                console.log('Adding column...')
                let columnNumber = this.section.columns.length + 1
                this.section.columns.push({
                    key: '2342342',
                    title: 'Column ' + columnNumber,
                    name: 'column_' + columnNumber,
                })
            }
            if(eventString == 'save-section') {
                this.saveSection(payload)
            }
            if(eventString == 'clone-element') {
                this.cloneElement(payload)
            }
        },

        saveSection(section) {
            console.log('Saving section...')

            section.page = this.page
            
            let ref = DataHelpers.getTenantRef().child('sections')
            Utilities.removeUndefinedProperties(section)
            FireData.saveItem(section, ref)

        },

        cloneElement(element) {
            console.log('Cloning element...', element)

        },

        afterDrag() {

        },

        prepareElement(element, colIndex, elIndex) {
            //mutates...
            element.colIndex = colIndex
            element.elIndex = elIndex
        },

        windowResized() {
            console.log ('setting to ' + this.$el.offsetWidth)
            this.componentWidth = this.$el.offsetWidth
        },

        debouncedWindowResized: Utilities.debounce( function(event, vm) {  
            vm.windowResized()          
        }, 500)

    },
    mounted() {
        this.windowResized()
    },

    created() {
        window.addEventListener('resize', this.debouncedWindowResized.bind(null, event, this))
    },

    destroyed() {
        document.removeEventListener("resize", this.debouncedWindowResized)
    },
}
</script>

<style scoped>
   .column-detail {display:flex; flex-wrap:wrap;}
   .column-outer {padding:0px;}

    /* @media (min-width: 500px) {
        .section-content {
            display:flex;
        }
    } */

</style>




// WEBPACK FOOTER //
// Section.vue?7ee4403c